<app-modal *ngIf="vo$ | async; let vo" class="app-models-selection-modal">
	<mat-accordion multi="false" modal-body>
		<!-- COLUMN MODEL SELECTION -->
		<mat-expansion-panel
			[expanded]="vo.currentStep === ModelsSelectionStep.ColumnModel"
			(opened)="setStep(ModelsSelectionStep.ColumnModel)">
			<mat-expansion-panel-header
				[ngClass]="vo.errors.get(SubscriptionErrorKey.NoSelectColumnModel) ?  'invalid-step': 'valid-step'">
				<mat-panel-title
					i18n="@@subscription.simulator.models.columnModelSelectionStep.title">
					column-models</mat-panel-title>
				<mat-panel-description
					i18n="@@subscription.simulator.models.columnModelSelectionStep.description">
					column-model-selection-desc</mat-panel-description>
			</mat-expansion-panel-header>

			<app-column-models
				[columnModels]="vo.columnModels"
				[mode]="'SIMULATION'"
				[selectedId]="vo.selectedColumnModelId"
				(reloadColumnModels)="refreshColumnModels()"></app-column-models>

			<mat-action-row>
				<button
					mat-flat-button
					color="primary"
					(click)="nextStep()">
					<span
						i18n="@@general.stepper.next">
						next</span>
				</button>
			</mat-action-row>
		</mat-expansion-panel>

		<!-- FILTER MODELS SELECTION -->
		<mat-expansion-panel
			[expanded]="vo.currentStep === ModelsSelectionStep.FilterModel"
			(opened)="setStep(ModelsSelectionStep.FilterModel)">
			<mat-expansion-panel-header
				[ngClass]="vo.errors.get(SubscriptionErrorKey.NoSelectFilterModel) ?  'optional-step': 'valid-step'">
				<mat-panel-title
					i18n="@@subscription.simulator.models.filterModelSelectionStep.title">
					filter-models</mat-panel-title>
				<mat-panel-description
					i18n="@@subscription.simulator.models.filterModelSelectionStep.description">
					filter-models-selection-desc</mat-panel-description>
			</mat-expansion-panel-header>

			<app-filter-models
				[filterModels]="vo.filterModels"
				[availableColumns]="vo.subscriptionColumns"
				[mode]="'SIMULATION'"
				[selectedIds]="vo.selectedFilterModelIds"
				(reloadFilterModels)="refreshFilterModels()"></app-filter-models>

			<mat-action-row>
				<button
					mat-flat-button
					color="primary"
					(click)="previousStep()">
					<span
						i18n="@@general.stepper.back">
						back</span>
				</button>
			</mat-action-row>
		</mat-expansion-panel>
	</mat-accordion>

	<div modal-footer class="app-models-selection-modal__footer">
		<div *ngIf="vo.errors.valueSeq().first() as error"
				 class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': error.type === 'warning' }"
				color="warn"
				[svgIcon]="error.type === 'critic'? DcIcons.Error: DcIcons.Warning">
			</mat-icon>
			<span>{{error.message}}</span>
		</div>

		<button
			id="{{ cmpId }}-validate-btn"
			[color]="'primary'"
			[disabled]="vo.criticErrorCount !== 0"
			(click)="launchAction()"
			mat-raised-button>
			<span
				i18n="@@subscription.simulator.simulate.btn">
				simulate</span>
		</button>
	</div>
</app-modal>
